import React, {useEffect, useState} from 'react'
import styles from './index.module.css'
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc'
import Modal from './Modal'
import Table from '../../components/Table'
import Icon from '../../components/Icon'
import Confirmation from '../../components/Confirmation'
import {useDispatch, useSelector} from 'react-redux'
import {BiSolidTrashAlt} from 'react-icons/bi'
import {getCompanies, setPage, deleteCompany} from '../../actions/companies'
import {Pagination} from '../../components/Pagination'

const Index = () => {

    const dispatch = useDispatch()

    const [modal,
        setModal] = useState(false)
    const {list, list_loading, pageNumber, pageCount} = useSelector(state => state.companies)
    const [confirmation,
        setConfirmation] = useState(null);
    // const {itemsOnPage} = useSelector(state => state.auth) const [company,
    // setCompany] = useState(null)

    useEffect(() => {
        dispatch(getCompanies())
    }, [pageNumber])

    useEffect(() => {
        dispatch(getCompanies())
    }, [])

    // useEffect(() => {     pageClick({selected: 0})
    // dispatch(getCompanies(company?.value || null))   }, [itemsOnPage, company])

    const pageClick = ({selected}) => dispatch(setPage(selected))

    const acceptConfirmation = () => {
        dispatch(deleteCompany(confirmation.id))
        setConfirmation(null)
    }

    return (
        <div className={styles.wrapper}>

            {confirmation && <Confirmation
                confirmation={confirmation.name}
                acceptConfirmation={acceptConfirmation}
                rejectConfirmation={() => setConfirmation(null)}/>}

            <TitleAndDesc title='Поставщики'/>

            <Modal
                modal={modal}
                setModal={setModal}
                companies={list}
                setConfirmation={setConfirmation}/>

            {/* <Pagination
                pageCount={pageCount}
                pageNumber={pageNumber}
                onPageChange={pageClick}> */}

                <Table isEmpty={list} isLoad={list_loading}>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Название</th>
                            <th
                                style={{
                                width: '120px'
                            }}>Удалить</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(el => <tr key={el.id}>
                            <td onClick={() => setModal(el)}>{el.id}</td>
                            <td onClick={() => setModal(el)}>{el.name}</td>
                            <td
                                onClick={() => setConfirmation(el)}
                                key={el.id}
                                style={{
                                width: '120px'
                            }}
                                title='Удалить пользователя'>
                                <Icon color='red'><BiSolidTrashAlt/></Icon>
                            </td>
                        </tr>)}
                    </tbody>
                </Table>

            {/* </Pagination> */}
        </div>
    )
}

export default Index